"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
exports.GnosisSafeAccountFactory__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var ethers_1 = require("ethers");
var _abi = [
    {
        inputs: [
            {
                internalType: "contract GnosisSafeProxyFactory",
                name: "_proxyFactory",
                type: "address"
            },
            {
                internalType: "address",
                name: "_safeSingleton",
                type: "address"
            },
            {
                internalType: "contract EIP4337Manager",
                name: "_eip4337Manager",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "salt",
                type: "uint256"
            },
        ],
        name: "createAccount",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "nonpayable",
        type: "function"
    },
    {
        inputs: [],
        name: "eip4337Manager",
        outputs: [
            {
                internalType: "contract EIP4337Manager",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address"
            },
            {
                internalType: "uint256",
                name: "salt",
                type: "uint256"
            },
        ],
        name: "getAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "proxyFactory",
        outputs: [
            {
                internalType: "contract GnosisSafeProxyFactory",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
    {
        inputs: [],
        name: "safeSingleton",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address"
            },
        ],
        stateMutability: "view",
        type: "function"
    },
];
var _bytecode = "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";
var isSuperArgs = function (xs) { return xs.length > 1; };
var GnosisSafeAccountFactory__factory = /** @class */ (function (_super) {
    __extends(GnosisSafeAccountFactory__factory, _super);
    function GnosisSafeAccountFactory__factory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = this;
        if (isSuperArgs(args)) {
            _this = _super.apply(this, args) || this;
        }
        else {
            _this = _super.call(this, _abi, _bytecode, args[0]) || this;
        }
        return _this;
    }
    GnosisSafeAccountFactory__factory.prototype.deploy = function (_proxyFactory, _safeSingleton, _eip4337Manager, overrides) {
        return _super.prototype.deploy.call(this, _proxyFactory, _safeSingleton, _eip4337Manager, overrides || {});
    };
    GnosisSafeAccountFactory__factory.prototype.getDeployTransaction = function (_proxyFactory, _safeSingleton, _eip4337Manager, overrides) {
        return _super.prototype.getDeployTransaction.call(this, _proxyFactory, _safeSingleton, _eip4337Manager, overrides || {});
    };
    GnosisSafeAccountFactory__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    GnosisSafeAccountFactory__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    GnosisSafeAccountFactory__factory.createInterface = function () {
        return new ethers_1.utils.Interface(_abi);
    };
    GnosisSafeAccountFactory__factory.connect = function (address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    };
    GnosisSafeAccountFactory__factory.bytecode = _bytecode;
    GnosisSafeAccountFactory__factory.abi = _abi;
    return GnosisSafeAccountFactory__factory;
}(ethers_1.ContractFactory));
exports.GnosisSafeAccountFactory__factory = GnosisSafeAccountFactory__factory;
